// extracted by mini-css-extract-plugin
export default {"root":"switch_root__ctfEB","thumb":"switch_thumb__2Sedq","label":"switch_label__DkjN0","check":"switch_check__20Xgg","x":"switch_x__T6rTC"};